<template>
  <div class="content">
    <v-app>
      <v-content>
        <v-container>
          <div class="">
            <div class="my-4 text-h4 mx-2">{{ name }} 用户协议</div>

            <div class="text-h6 mb-4">一、用户协议总则</div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              1、本协议双方为
              <strong> {{people_name}} （以下简称"运营方"）</strong
              >和<strong>
                {{
                  name
                }}（包括手机APP、网站、小程序等产品提供的服务，以下简称"产品和服务"）</strong
              >的<strong>注册用户（以下简称"用户"）</strong>。
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              2、用户在注册前请仔细阅读本协议的条款，并按照页面上的提示完成全部注册程序。
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              3、用户在进行注册过程中点击“同意”按钮，即表示用户已充分知悉和完全接受本协议项下全部条款，进而与运营方达成本协议。
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              4、运营方有权不时对本协议项下相关规则作出修改或补充，并于网站公布。用户若继续使用即视为您接受修订后的本协议条款。
            </div>

            <div class="text-h6 mb-4">二、用户服务使用说明</div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              1、用户在注册时应按照注册提示填写准确的
              用户名、密码、手机号码、身份证信息、电子邮箱地址
              等相关个人资料，符合完整、准确、真实的要求。
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              2、用户一旦注册或者登录成功，便成为运营方合法的注册用户。用户应对其账号安全负全部责任，并应对其用户名下所进行的所有行为和事件承担相应的法律责任。
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              3、用户同意接受运营方通过或其他方式向用户发送有关商业信息。
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              4、运营方不对用户所发布信息的删除或储存失败负责。
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              5、运营方有判定用户的行为是否符合本网站服务条款要求的权利，如果用户违背了服务条款的规定，本网站有权对其用户所提供的网络服务进行中断或停止使用。
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              6、运营方提供账号删除服务，如果用户需要删除账号，可以通过本协议中的联系方式与我们联系。
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              7、用户不得以任何非法目的或其它方式对运营方的个人用户账号进行转让、转借、倒卖、账号共享等行为（用户账号仅限由其本人使用）。
            </div>

            <div class="text-h6 mb-4">三、协议内容的变更和修订</div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              1、运营方有权在必要时修改服务条款，修改后的协议可以在运营方上查看。
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              2、用户如果不同意运营方所改动的内容，可自行停止使用本站网络服务。
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              3、如果用户继续享用本站网络服务，则视为同意接受本网站服务条款的变动。
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              4、运营方可随时根据实际情况中断或终止一项或多项网络服务而无需对任何用户或第三方承担任何责任，如用户对一项或多项网络服务的中断或终止有异议，可以行使如下权利：
              <div class="mt-2">（1）自行停止使用运营方的网络服务。</div>
              <div>
                （2）通知运营方停止对该用户的服务。
                结束用户服务后，用户使用网络服务的权利立即终止，从终止时起，用户没有权利再进行处理任何未完成的信息或服务，运营方也没有义务为其传送任何未处理的信息或未完成的服务给用户或任何第三方。
              </div>
            </div>

            <div class="text-h6 mb-4">四、用户隐私保护</div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              运营方将严格履行用户个人隐私保密义务，承诺不公开、编辑或透露用户个人信息，但以下特殊情况除外：
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              1、经注册用户事先许可授权；
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              2、遵守国家法律法规或配合相关政府部门的要求；
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              3、遵从运营方合法服务程序；
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              4、为维护社会公众利益以及运营方的合法权益所必须。
            </div>

            <div class="text-h6 mb-4">五、注册用户的权利与义务</div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              1、注册用户在使用运营方产品和服务时，必须遵守中华人民共和国相关法律法规的规定，用户应同意将不会利用本服务进行任何违法或不正当的活动，否则用户将自行承担由此产生的一切法律责任。
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              2、用户在账号使用过程中不得上载、展示、张贴、传播或以其它方式传送含有下列内容之一的信息：
              <div class="mt-2">
                （1）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
              </div>
              <div>（2）损害国家荣誉和利益的；</div>
              <div>（3）煽动民族仇恨、民族歧视、破坏民族团结的；</div>
              <div>（4）破坏国家宗教政策，宣扬邪教和封建迷信的；</div>
              <div>（5）散布谣言，扰乱社会秩序，破坏社会稳定的；</div>
              <div>（6）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</div>
              <div>（7）侮辱或者诽谤他人，侵害他人合法权利的；</div>
              <div>
                （8）含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容。
              </div>
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              3、不得为任何非法目的而使用网络服务系统。
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              4、不得利用运营方产品和服务故意制作、传播计算机病毒等破坏性程序，或其他从事任何危害计算机信息网络安全的行为。
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              5、若用户行为违反上述约定，运营方有权作出独立判断并立即取消用户的服务账号，用户应对自己网上的行为承担一切法律责任，运营方的系统记录有可能作为用户违反法律的证据提交给相关主管部门。
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              6、用户应同意保障和维护运营方全体成员及其他用户的利益，如因违反本协议或违反有关的法律法规而给运营方或任何第三者造成损失，用户应承担因此产生的法律责任。
            </div>

            <div class="text-h6 mb-4">六、运营方网络服务内容的所有权</div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              1、运营方定义的网络服务内容包括但不限于：内部资料信息等。该等内容均受《著作权法》、《商标法》、《专利法》、《计算机软件保护条例》及其他相关法律法规的保护。
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              2、未经运营方或其他有权第三方的事先许可授权，用户不得对包括但不限于：软件源码、商标等在内的任何内容进行转载、翻录、复制、发行、破解、信息网络传播或其他违反知识产权相关法律、法规的行为，否则所导致的一切民事、行政或刑事责任，由用户自行承担。
            </div>

            <div class="text-h6 mb-4">七、免责声明</div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              1、用户同意承担使用运营方产品和服务所存在的一切风险以及因使用网络服务而产生的一切后果，运营方对用户不承担任何责任。
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              2、运营方不担保服务一定能满足用户的要求，也不担保服务不会中断，亦对服务的及时性，安全性及可能发生的技术错误均不作任何担保。
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              3、任何由于黑客攻击、计算机病毒侵入或发作、政府管制、硬件故障、不可抗力等非运营方故意或严重过失而造成的用户个人资料泄露、丢失、被盗用、被篡改或服务暂定或终止的，对用户可能造成的风险或损失，运营方不承担法律责任。
            </div>

            <div class="text-h6 mb-4">八、其他约定</div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              1、用户同意因本平台服务产生的任何争议均适用中华人民共和国法律，相关争议任何一方可向运营方住所地人民法院提起诉讼解决。
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              2、本协议中的标题仅为方便而设，不影响对于条款本身的解释。本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，其余条款仍应具有约束力。
            </div>

            <div class="text-h6 mb-4">九、联系我们</div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              如果您对本协议或本服务有任何疑问、意见或建议，可通过以下方式与我们联系：
            </div>
            <div class="text-muted mb-4" style="text-indent: 2em">
              <div class="mt-2">（1）拨打客服热线电话400-000-7318</div>
              <div>（2）发送电子邮件至：k@daxiangsys.com</div>
              <div>
                （3）联系地址：湖南省长沙市岳麓区望城坡街道枫林三路49号换乘大楼101一楼南侧105，联系人：客服
              </div>
            </div>

            <div style="padding: 10px 0 10px 25px">
              <div>发布时间 2024-01-01</div>
              <div>生效时间 2024-01-01</div>
              <div>更新时间 2025-01-08</div>
            </div>

            <div class="text-muted mb-4" style="text-indent: 2em">（完）</div>
          </div>
        </v-container>
      </v-content>
    </v-app>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      people_name:'大象系统'
    };
  },
  mounted() {
    var query = this.$route.query;
    if (query.name) {
      this.name = query.name;
    } else {
      this.name = "大象系统";
    }
  },
};
</script>

<style scoped>
.content {
  padding: 20px;
}
</style>
